// module/exams/ducks/reducer.ts - Exam Saga Reducer

import * as R from 'ramda'
import { Action, VideosReducer } from 'types'
import { API_STATES } from 'utils/redux'
import {
  fetchVideosListRoutine,
  fetchVideosListWithInfiniteScrollRoutine,
  resetVideosListRoutine
} from 'modules/videos/ducks/actions'
import { mapObjIndexed } from 'ramda'

export const initialState: VideosReducer = {
  state: API_STATES.PRISTINE,
  videos: [],
  pagination: {
    page: 1,
    take: 10,
    recordsTotal: 0,
    pagesTotal: 1
  }
}

export default (state = initialState, action: Action): VideosReducer => {
  switch (action.type) {
    case fetchVideosListRoutine.REQUEST:
    case fetchVideosListWithInfiniteScrollRoutine.REQUEST:
      return {
        ...state,
        state: API_STATES.IN_PROGRESS
      }
    case fetchVideosListRoutine.FAILURE:
    case fetchVideosListWithInfiniteScrollRoutine.FAILURE:
      return {
        ...state,
        state: API_STATES.DONE
      }
    case fetchVideosListRoutine.SUCCESS:
      return {
        ...state,
        state: API_STATES.DONE,
        videos: action.payload.data,
        pagination: R.mapObjIndexed(value => Number(value), action.payload.meta)
      }
    case fetchVideosListWithInfiniteScrollRoutine.SUCCESS:
      return {
        ...state,
        state: API_STATES.DONE,
        videos: R.uniqBy(R.prop('id'), [
          ...state.videos,
          ...action.payload.data
        ]),
        pagination: mapObjIndexed(value => Number(value), action.payload.meta)
      }
    // Sync reset once on TRIGGER only.
    // Handling SUCCESS too creates a second pagination object and fires the
    // fetch effect twice for the same filter (duplicate identical API calls).
    case resetVideosListRoutine.TRIGGER:
      return {
        ...state,
        videos: [],
        state: API_STATES.PRISTINE,
        pagination: {
          page: 1,
          take: 10,
          recordsTotal: 0,
          pagesTotal: 1
        }
      }
    default:
      return state
  }
}
